import {StyledStepButton, StyledStepsNavigation} from './style'
import {useTranslation} from '@/translations/i18n'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {FC} from 'react'
import {stepToIcon, stepToLabel} from '@/features/experience-shell/utils'
import {ExperienceStepKeyName} from '@/features/experience-view-only/types'

export const StepsNavigation: FC<{
    currentStep: ExperienceStepKeyName
    onStepClick: (step: ExperienceStepKeyName) => void
}> = ({currentStep, onStepClick}) => {
    const {t} = useTranslation()

    return (
        <StyledStepsNavigation>
            {ExperienceStepKeyName.options.map(step => {
                const StepIcon = stepToIcon[step]
                return (
                    <StyledStepButton
                        className={currentStep == step ? 'active' : undefined}
                        variant="ghost"
                        onClick={() => onStepClick(step)}
                        key={step}
                    >
                        <Flexbox align="center" gap={2}>
                            <StepIcon />
                            {t(stepToLabel[step])}
                        </Flexbox>
                    </StyledStepButton>
                )
            })}
        </StyledStepsNavigation>
    )
}
